module.exports = __webpack_public_path__ + "assets/img/inndot_b.a393f25d.png";